import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { INotificationEvents } from "@/models/ApiRequestResponse/notification";

import { setIsShowNotification } from "@/store/slices/config";

export const useNotificationNavigation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNotificationClick = useCallback(
    (event_type: INotificationEvents) => {
      dispatch(setIsShowNotification(false));

      switch (event_type) {
        case INotificationEvents.APPOINTMENT_BOOKED:
        case INotificationEvents.APPOINTMENT_BOOKED_BY_OTHERS:
        case INotificationEvents.APPOINTMENT_CANCELED:
        case INotificationEvents.VIDEO_CALL_INVITATION:
        case INotificationEvents.MEDICINE_HOME_DELIVERY_ORDER_COMPLETED:
        case INotificationEvents.MEDICINE_HOME_DELIVERY_ORDER_REJECTED:
        case INotificationEvents.MEDICINE_HOME_DELIVERY_ORDER_ACCEPTED:
        case INotificationEvents.MEDICINE_PICKUP_ORDER_ACCEPTED:
        case INotificationEvents.MEDICINE_PICKUP_ORDER_REJECTED:
        case INotificationEvents.MEDICINE_PICKUP_ORDER_COMPLETED:
        case INotificationEvents.PENDING_MEDICINE_ORDER_REQUEST:
        case INotificationEvents.CONSULTATION_END_REMINDER:
        case INotificationEvents.VIDEO_CONSULTATION_REMINDER:
        case INotificationEvents.IN_CLINIC_APPOINTMENT_REMINDER:
        case INotificationEvents.TEST_ORDER_REJECTED:
        case INotificationEvents.TEST_REPORT_UPLOADED:
        case INotificationEvents.TEST_ORDER_ACCEPTED:
        case INotificationEvents.TEST_ORDER_COMPLETED:
        case INotificationEvents.PENDING_DIAGNOSTIC_ORDER_REQUEST:
          navigate("/order-list");
          break;

        case INotificationEvents.PATIENT_MEDICINE:
          navigate("/medicines");
          break;

        case INotificationEvents.PATIENT_TESTS:
          navigate("/test-reports");
          break;

        case INotificationEvents.PATIENT_HEALTH_HUB:
          navigate("/health-hub");
          break;

        case INotificationEvents.DOCTOR_IP_DASH:
        case INotificationEvents.HOSPITAL_LINKED_TO_DOCTOR:
        case INotificationEvents.PATIENT_ADMITTED_BY_OTHERS:
          navigate("/ip-dash", { state: { navItem: 1 } });
          break;

        case INotificationEvents.PATIENT_ASSESSMENT:
          navigate(`/health-assessment?type=Brain`);
          break;

        case INotificationEvents.PATIENT_CHAT:
        case INotificationEvents.NEW_ADMITTED_PATIENT_CHAT:
        case INotificationEvents.NEW_PATIENT_APPOINTMENT_CHAT:
        case INotificationEvents.PATIENT_DISCHARGED:
          navigate(`/chat`);
          break;

        case INotificationEvents.SIGNUP:
          navigate("/medical-records", {
            state: {
              isEditProifleShow: true,
            },
          });
          break;
      }
    },
    [dispatch, navigate]
  );

  return { handleNotificationClick };
};
